//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/OpenXml.js";
import "../OpenXml/OpenXml.DocumentData.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetColumnCount",{R_:{columnCount:''}},0,0],[[],"GetRowCount",{R_:{columnCount:''}},0,0],[["position"],"GetCaption",{R_:{caption:''}},0,0],[["position","caption"],"SetCaption",{},2,0],[["nColumns"],"GetColumnWidths",{R_:{widths:""}},0,0],[["widths"],"SetColumnWidths",{},1,0],[["nRows"],"GetRowHeigths",{R_:{heigths:""}},0,0],[["heigths"],"SetRowHeigths",{},1,0],[["grids"],"AddCellData",{R_:{cell:"OpenXml.TableCellData"}},1,0],[[],"GetCellsCount",{R_:{cellsCount:''}},0,0],[["index"],"GetNthCell",{R_:{cell:"OpenXml.TableCellData"}},1,0]],[]];
SPLM.OpenXml.TableDocumentData = class extends SPLM.OpenXml.DocumentData{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.OpenXml.TableDocumentData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.OpenXml.TableDocumentData.CaptionPosition = Object.freeze({
    "Above" : "Above", "Bellow" : "Bellow"});

export default SPLM;